import {
	Component,
	HostListener,
	Input,
	OnInit,
	SecurityContext,
	ViewChild,
	ViewEncapsulation
} from '@angular/core';
import { AuthService } from '../../services/authservice/auth.service';
import { DatePipe } from '@angular/common';
import { NoteService } from '../../services/note.service';
import { Notes } from '../../models/note';
import { NoteCategory } from '../../models/note-category';
import { Settings } from '../../services/settings';
import { UserService } from '../../services/user.service';
import { DomSanitizer } from '@angular/platform-browser';
import { User } from '../../models/user';
import { NotesHelper } from './notes.helper';
import { DwUtils } from '../utils/dw-utils';

class dataRecord {
	id: string;
	description: string;
	constructor(id: string, desc: string) {
		this.id = id;
		this.description = desc;
	}
}
@Component({
	selector: 'app-notes',
	templateUrl: './notes.component.html',
	styleUrls: ['./notes.component.css'],
	providers: [DatePipe],
	encapsulation: ViewEncapsulation.None,
})

export class NotesComponent implements OnInit {

	private _parentId: number;
	private _callingComponent: any;
	private _heightAdjust = '350';
	private _width = '350';
	private submitDate: string;
	public fullName;
	public taNoteText: string;
	public taNoteHistoryTxt: string;
	public disabledFlag = true;

	public noteListTotal: any;
	public noteList: any;
	
	public restrictedAgencyFlag =false;

	avatarImageURL = '' + Settings.getInstance().BASE_URL + 'users/profile/image/';
	loggedInUser: User;
	_dialog_mode = false;
	containerHeight = '';
	private TEXT_AREA_ELEMENT_ID = 'ta-note-text';
	isEmojiPickerVisible = false;
	users: Array<User>;
	helper: NotesHelper;
	htmlDoc: any;
	rowIndex = -1;
	editFlag = false;
	editedNoteIdx = -1;
	viewClass = 'rendered-notes-container';
	_view = '';
	_readOnly: boolean = false;

	noteCategory: string;
	noteFilterCategory: string;
	categoryDataSource: any;			/** used when adding or editing a note **/
	categoryFilterSource: any;			/** used when filtering the display of notes **/

	public mentionConfig: any;
	public _primaryAgencyFlag: boolean = false;

	@Input() set primaryAgencyFlag(val: boolean) {
		this._primaryAgencyFlag = val;
	}

	@ViewChild('taNote') taNote: any;

	@Input() set readOnly(value: boolean) {
		this._readOnly = value;
	}
	get readOnly(): boolean {
		return this._readOnly;
	}
	@Input() set parentId(value: number) {
		this._parentId = value;

		if (value === undefined || value <= 0) {
			this.disabledFlag = true;
			this.taNoteText = '';
			this.taNoteHistoryTxt = '';
			return;
		}
	}

	get parentId(): number {
		return this._parentId;
	}

	@Input() set recordSelected(val: boolean) {
		this.disabledFlag = val;
	}
	get recordSelected(): boolean {
		return this.disabledFlag;
	}
	@Input() set callingComponent(value: string) {
		this._callingComponent = value;
	}
	get callingComponent(): string {
		return this._callingComponent;
	}

	@Input() set heightAdjust(value: any) {
		this._heightAdjust = value;
		if (this._dialog_mode && value === 700) {
			this.containerHeight = '230px';
		} else {
			this.containerHeight = 'calc(100vh - ' + this.heightAdjust + 'px)';
		}
	}
	get heightAdjust(): string {
		return this._heightAdjust;
	}

	@Input() set width(value: string) {
		this._width = value;
	}
	get width(): string {
		return this._width;
	}

	@Input() set View(value: any) {
		this._view = value;
		if (this._view === 'Window') {
			this.viewClass = 'rendered-notes-container-window';
		} else {
			this.viewClass = 'rendered-notes-container';
		}
	}

	fromSource: string;
	@Input() set from(value: string) {
		this.fromSource = value;
	}

	showNotes = false;
	showAdd = false;
	showEdit = false;
	showDelete = false;
	showallAgencyNotes = false;
	showRestrictedAgencyNotes = false;
	showCategoryFilter = false;


	constructor(private datePipe: DatePipe,
		private authService: AuthService,
		private notesService: NoteService,
		private userService: UserService,
		private sanitizer: DomSanitizer) {

		this.fullName = this.authService.loggedInUser;   // uncomment me
		this.helper = new NotesHelper();
		this.categoryDataSource = [];
		this.categoryFilterSource = [];


	}
	setSecurityPrivileges() {
		if (this.fromSource === 'cases') {
			this.showNotes = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_NOTES', "SHOW");
			this.showAdd = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_NOTES_ADD', "EXECUTE");
			this.showEdit = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_NOTES_EDIT', "EXECUTE");
			this.showDelete = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_NOTES_DELETE', "EXECUTE");
			this.showallAgencyNotes = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_NOTES_ALL', "SHOW");
			this.showRestrictedAgencyNotes = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_NOTES_AGENCY_ONLY', "SHOW");
			this.showCategoryFilter = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_NOTES_CATEGORY_FILTER', "SHOW");

		} else if (this.fromSource === 'requests') {
			this.showNotes = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_NOTES', "SHOW");
			this.showAdd = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_NOTES_ADD', "EXECUTE");
			this.showEdit = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_NOTES_EDIT', "EXECUTE");
			this.showDelete = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_NOTES_DELETE', "EXECUTE");
			this.showallAgencyNotes = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_NOTES_ALL', "SHOW");
			this.showRestrictedAgencyNotes = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_NOTES_AGENCY_ONLY', "SHOW");
			this.showCategoryFilter = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_NOTES_CATEGORY_FILTER', "SHOW");
		} else {
			this.showNotes = true;
			this.showAdd = true;
			this.showEdit = true;
			this.showDelete = true;
			this.showallAgencyNotes = true;
			this.showRestrictedAgencyNotes = true;
			this.showCategoryFilter = true;

		}
		if(this.showallAgencyNotes === false && this.showRestrictedAgencyNotes === true){
			this.restrictedAgencyFlag = true;
		}

	}
	public fetchNoteCategories(): void {

		this.notesService.getAllActiveNoteCategories().subscribe(
			(results) => {

				this.categoryFilterSource.push(new dataRecord('All Categories', 'All Categories'));

				for (let i = 0; i < results.length; i++) {

					if ((results[i].description === 'Private') && (this._primaryAgencyFlag === false)) {
						continue;
					}

					this.categoryDataSource.push(new dataRecord(results[i].description, results[i].description));
					this.categoryFilterSource.push(new dataRecord(results[i].description, results[i].description));

				}
				/** set the first item in the list as the
				 * primary category - in this case it will be 'General'
				 */
				if (results.length > 0) {
					this.noteCategory = this.categoryDataSource[0].description;
					this.noteFilterCategory = this.categoryFilterSource[0].description;
				}
			},
			(error) => {
				Settings.getInstance().handleError(error, 'fetching note categories');
			}
		)

	}
	public selectEnd() {
		let range;
		let selection;

		range = document.createRange();

		this.htmlDoc = document.getElementById(this.TEXT_AREA_ELEMENT_ID);
		range.selectNodeContents(this.htmlDoc);
		range.collapse(false);
		selection = window.getSelection();
		selection.removeAllRanges();
		selection.addRange(range);
	}
	public ngOnInit() {
		this.taNoteText = '';
		this.taNoteHistoryTxt = '';
		this.loggedInUser = Settings.getInstance().loggedInUser;
	}
	public setInitialFocus() {
		this.helper.setFocus(this.TEXT_AREA_ELEMENT_ID);
	}
	public messageMouseOver(event: any, idx: any): void {

		if (event.target.tagName === 'SPAN') {
			this.rowIndex = idx;

			// we have either a mention or a hashtag.
			const textKey = event.target.textContent;
			// check to see if this is an at mention.
		}
	}
	public messageMouseOut(event: any): void {

		if (event.target.tagName === 'SPAN') {
			this.rowIndex = -1;
		}
	}
	public onShowHandler() {

		if (this.parentId === 0) {
			this.disabledFlag = true;
			return;
		}
		this.setSecurityPrivileges();
		if(this.showallAgencyNotes===false &&this.showRestrictedAgencyNotes===false){
			return;
		}
		this.disabledFlag = false;

		this.fetchNoteCategories();
		

		this.notesService.getNotesByForeignKeyId(this.parentId, this.callingComponent, this.restrictedAgencyFlag).subscribe(
			(results) => {
				this.noteListTotal = [];
				for (let i = 0; i < results.length; i++) {
					if ((results[i].noteCategory === 'Private') && (this._primaryAgencyFlag === false)) {
						continue;
					}
					this.noteListTotal.push(results[i]);
				}
				this.noteListTotal = this.noteListTotal.reverse();
				this.displayNotes(this.noteFilterCategory);
			},
			(error) => {
				Settings.getInstance().handleError(error, 'fetching notes');
			}
		);
	}
	public getSanitizedURL(userUid: string): string {

		let retURLVal = '';
		try {
			const id = Settings.getInstance().usersList.find(u => u.username === userUid).id;
			retURLVal = this.avatarImageURL + id;
		} catch (Exception) {
			return retURLVal;
		}
		return retURLVal;
	}
	public doFilterView(item: string): void {

		this.displayNotes(item);
	}
	public displayNotes(filterItem: string): void {

		this.noteList = [];

		for (let i = 0; i < this.noteListTotal.length; i++) {

			if ((filterItem === 'All Categories') || (filterItem === this.noteListTotal[i].noteCategory) || (!filterItem)) {

				let noteRecord = this.noteListTotal[i];
				this.taNoteHistoryTxt = '';

				// Jiggery-pokery with the date :(
				const tempDate: string =
					DwUtils.returnTZTime(new Date(noteRecord.dateAdded));
				noteRecord.dateAdded = DwUtils.formatDTFromISOStringWhithoutSeconds(tempDate);

				if (noteRecord.commentText === undefined) {
					noteRecord.commentText = '';
				}
				noteRecord.commentText = noteRecord.commentText.replace(/(?:\r\n|\r|\n)/g, '<br>');
				this.noteList.push(noteRecord);
			}

		}

	}
	public submitNewNote() {

		if (this.validateNewTextNote() === false)
			return;

		if (document.getElementById(this.TEXT_AREA_ELEMENT_ID).textContent.length > 0) {
			this.addNote();
		}
		//  this.taNoteText = '';
		document.getElementById(this.TEXT_AREA_ELEMENT_ID).focus();
	}
	public addNote() {

		if (this.editFlag === false) {
			const newNote = new Notes();
			newNote.id = 0;
			newNote.foreignKeyTable = this._callingComponent;
			newNote.dateAdded = DwUtils.returnCurrentDateTime();
			newNote.foreignKeyId = this.parentId;
			newNote.noteCategory = this.noteCategory;
			newNote.commentText = this.prepComment(document.getElementById(this.TEXT_AREA_ELEMENT_ID).innerHTML);
			newNote.userUid = Settings.getInstance().loggedInUser.username;
			newNote.userFullName = Settings.getInstance().loggedInUser.name;

			this.notesService.createNote(newNote).subscribe(
				(data) => {
					newNote.id = data['id'];
					this.noteList.unshift(newNote);
					this.noteListTotal.unshift(newNote);
				},
				(error) => {
					// To-Do
				}
			);

		} else {
			this.noteList[this.editedNoteIdx].commentText =
				this.prepComment(document.getElementById(this.TEXT_AREA_ELEMENT_ID).innerHTML);

			this.noteList[this.editedNoteIdx].noteCategory = this.noteCategory;

			this.notesService.updateNote(this.noteList[this.editedNoteIdx]).subscribe(
				(data) => {
					//nothing
					(error) => {
						// nothing
					}
				}
			);
			this.editFlag = false;
			this.editedNoteIdx = -1;

		}
		// clear the text area.
		document.getElementById(this.TEXT_AREA_ELEMENT_ID).textContent = '';
	}
	public prepComment(inpStr: string): string {

		let htmlText = '';

		if (this.editFlag === true) {
			htmlText = inpStr + this.helper.editBanner;
		}
		else {
			htmlText = inpStr;
		}

		const safeHtml = this.sanitizer.sanitize(SecurityContext.HTML, htmlText);
		return safeHtml;
	}
	public validateNewTextNote(): boolean {

		this.taNoteText = document.getElementById(this.TEXT_AREA_ELEMENT_ID).textContent;
		return true;
	}
	public editDisplayedMessage(idx: number): void {

		if (idx < 0) {
			return;
		}
		// set the edit flag to true ...
		// and capture the index ..
		this.editFlag = true;
		this.editedNoteIdx = idx;
		//   this.taNoteText = '';
		// Sanitize to remove security context messages
		let htmlTextContent = this.sanitizer.sanitize(SecurityContext.HTML, this.noteList[idx].commentText);
		// strip off any previous edit banner: '(Edited)'
		htmlTextContent = htmlTextContent.replace(this.helper.editBanner, '');

		// put the selected message back in the edit box
		setTimeout(() => {
			const el = document.getElementById(this.TEXT_AREA_ELEMENT_ID);
			if (el) {
				el.innerHTML = htmlTextContent.toString();
				this.helper.setFocus(this.TEXT_AREA_ELEMENT_ID);
				this.selectEnd();
			}
		});

		// set the noteCategory
		this.noteCategory = this.noteList[idx].noteCategory;



		// set focus back to the text field and move the
		// i-beam position to the end of the text.
		this.helper.setFocus(this.TEXT_AREA_ELEMENT_ID);
		this.selectEnd();

	}
	public deleteDisplayedMessage(idx: number): void {

		this.notesService.deleteNote(this.noteList[idx].id).subscribe(
			(data) => {
				const nIdx = this.noteListTotal.findIndex(s => s.id === this.noteList[idx].id);
				this.noteListTotal.splice(nIdx, 1);
				this.noteList.splice(idx, 1);

			},
			(error) => {
				console.log('cannot delete note at position: ' + idx);
			}
		);
	}
	public cancelEditClicked(event: any): void {
		this.editFlag = false;
		this.editedNoteIdx = -1;
		document.getElementById(this.TEXT_AREA_ELEMENT_ID).textContent = '';
		this.helper.setFocus(this.TEXT_AREA_ELEMENT_ID);
	}
	public validateEditNote(username: string): boolean {
		// Only show the menu if the author of the note is the
		// person logged in

		if (username === this.loggedInUser.username)
			return true;

		return false;
	}
}
